// Module
var code = "<div> <h4>{{$ctrl.confirmationEntity | translate}}</h4> <div class=\"form-container-footer\"> <button class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\"> {{'Gui.Buttons.Cancel' | translate}} </button> <button class=\"btn btn-default\" ng-click=\"$ctrl.onOk()\"> {{'Gui.Common.Yes' | translate}}</button> </div> </div>";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/ConfirmationModal/ConfirmationModal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;